import React, { useContext } from "react";
import { css } from "emotion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { colors, textSizes, boxStyles } from "../../styles/theme";
import TitleBlock from "../TitleBlock";
import {useLocation, withRouter} from "react-router-dom";

const TargetingHeaderMobile = ({ history }) => {
  const query = new URLSearchParams(useLocation().search);
  const lastLocation = query.get('lastLocation');

  const handleBack = () => {
    history.push(lastLocation);
  };

  return (
    <div className={container}>
      <div className="back-btn" onClick={handleBack}>
        <FontAwesomeIcon className="icon" icon="chevron-left" />
        <p>BACK</p>
      </div>
      <TitleBlock
        title='Advanced Options'
        subtitle='Display this spotlight to visitors based on UTM parameters, page URL, etc.'
        style="title-block"
      />
    </div>
  );
};

export default withRouter(TargetingHeaderMobile);

const container = css`
  .back-btn {
    padding: ${boxStyles.standardPadding};
    display: flex;
    align-items: center;
    color: ${colors.placeholderText};
    font-size: ${textSizes.normal};
    cursor: pointer;
    p {
      padding-left: 5px;
    }
  }

  .title-block {
    min-height: 140px;
    margin: 0;
    
    p {
      max-width: 300px;
    }
  }
`;
